import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_2 = {
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#novogrupo"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "float-start" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Formulários do Grupo: ")
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "card mb-0 h-100" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "dropdown float-end" }
const _hoisted_12 = {
  href: "#",
  class: "dropdown-toggle arrow-none card-drop",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Novo")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0);",
  class: "dropdown-item"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-content-copy me-1" }),
  /*#__PURE__*/_createTextVNode(" Copy List")
], -1)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Detele")
const _hoisted_22 = { class: "header-title" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  class: "text-muted fw-normal mt-0 text-truncate",
  title: "Campaign Sent"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-4\"><div class=\"flex-shrink-0\"><h6 class=\"font-13 text-muted my-0\"></h6></div><div class=\"flex-grow-1 ms-2\"></div><div class=\"text-end\"><div class=\"row g-1\"></div></div></div>", 1)
const _hoisted_26 = { class: "col-sm-1 col-xl-1 mb-2" }
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "border-dashed h-100 w-100 rounded d-flex align-items-center justify-content-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "font-16 mt-1 mb-0 d-block" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "card-footer text-muted" }, null, -1)
const _hoisted_32 = {
  class: "modal fade",
  id: "editform",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_33 = {
  class: "modal fade",
  id: "novoform",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_EditFormGroup = _resolveComponent("EditFormGroup")!
  const _component_NewFormGroup = _resolveComponent("NewFormGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, { icon: "file" })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (g) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "pt-3 pb-2 mb-3",
        key: g.id
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("strong", null, _toDisplayString(g.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.forms, (form) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-sm-3 col-xl-3 mb-3",
                  key: form.id
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("a", _hoisted_12, [
                          _createVNode(_component_font_awesome_icon, { icon: "newspaper" })
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "dropdown-item",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#novoform",
                            id: "btnnovoform",
                            onClick: ($event: any) => ($setup.formnovo(g.id))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" }),
                            _hoisted_15
                          ], 8, _hoisted_14),
                          _hoisted_16,
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "dropdown-item",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#editform",
                            id: "btneditform",
                            onClick: ($event: any) => ($setup.formedit(g.id,form.id))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" }),
                            _hoisted_18
                          ], 8, _hoisted_17),
                          _hoisted_19,
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "dropdown-item text-danger",
                            onClick: ($event: any) => ($setup.delform(form.id))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "trash-alt" }),
                            _hoisted_21
                          ], 8, _hoisted_20)
                        ])
                      ]),
                      _createElementVNode("h5", _hoisted_22, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          class: "text-decoration-none",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#editform",
                          id: "btneditform",
                          onClick: ($event: any) => ($setup.formedit(g.id,form.id))
                        }, _toDisplayString(form.name), 9, _hoisted_23)
                      ]),
                      _createElementVNode("h6", _hoisted_24, _toDisplayString(form.description), 1),
                      _hoisted_25
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      class: "text-center text-muted p-2",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#novoform",
                      id: "cardnovoform",
                      onClick: ($event: any) => ($setup.formnovo(g.id)),
                      title: "Novo form"
                    }, [
                      _createElementVNode("h1", _hoisted_30, [
                        _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
                      ])
                    ], 8, _hoisted_29)
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_31
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(_component_EditFormGroup, {
        onUpdateGroupForm: $setup.triggerForm,
        dadosForm: $setup.dadosForm,
        formid: $setup.formid
      }, null, 8, ["onUpdateGroupForm", "dadosForm", "formid"])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_NewFormGroup, {
        onUpdateGroupForm: $setup.triggerForm,
        groupid: $setup.groupid
      }, null, 8, ["onUpdateGroupForm", "groupid"])
    ])
  ]))
}